import React, { useState, useEffect } from 'react'
import CsvExportModal from '../../../../../../components/generic/CsvExportModal';


const ExportConnectedAccountModal = (props) => {

    const [exportData, setExportData] = useState([]);

    useEffect(() => {
        const tableDataArray = props.tableData;
        if (!tableDataArray || tableDataArray.length < 1) return;

        const allGroupNames = new Set();

        // First pass: collect all unique group names from tags
        tableDataArray.forEach(account => {
            if (Array.isArray(account?.generic_tags)) {
                account.generic_tags.forEach(tag => {
                    if (tag.group?.name) {
                        allGroupNames.add(tag.group.name);
                    }
                });
            }
        });

        const groupColumns = Array.from(allGroupNames); // Will become dynamic column names

        const newExportData = tableDataArray.map(account => {
            const unknownValuesAsBlank = (value) =>
                typeof value === "string"
                    ? value.replace(/^(unknown)$/i, "")
                    : value;

            const row = {
                "Institution Name": unknownValuesAsBlank(account?.account?.bank?.name),
                "Account Name": unknownValuesAsBlank(account?.description),
                Balance: unknownValuesAsBlank(account?.account?.aggregated_balance),
                Purpose: unknownValuesAsBlank(account?.purpose?.name),
                "Connection Status": unknownValuesAsBlank(
                    account.account?.api_connection_status_live ? "Live" : "Not Live"
                ),
                "Holding Entity": unknownValuesAsBlank(account?.beneficiary?.name || account?.entity_name),
                "Account Number Last 4": unknownValuesAsBlank(
                    account?.account?.account_number_last_4 != null
                        ? `'${String(account.account.account_number_last_4)}`
                        : ""
                ),
                "Routing Number": unknownValuesAsBlank(account?.account?.routing_number),
            };

            // Add a field for each group, if the account has tags for it
            groupColumns.forEach(groupName => {
                const tagsInGroup = (account?.generic_tags || []).filter(tag => tag.group?.name === groupName);

                const tagPaths = tagsInGroup.map(tag => {
                    const parentNames = [];
                    let currentParent = tag.parent;
                    while (currentParent) {
                        parentNames.unshift(currentParent.name);
                        currentParent = currentParent.parent;
                    }
                    return [...parentNames, tag.name].join(" > ");
                });

                row[groupName] = tagPaths.join("; "); // Join multiple tag paths with semicolon
            });

            return row;
        });

        setExportData(newExportData);
    }, [props.tableData]);


    return (

        <CsvExportModal
            data={exportData}
            fileName={"all-accounts"}
            downloadMessage={"Download information for ### connected account(s)."}
            modalVisible={props.csvModalVisible}
            handleCancelModal={props.handleCancelModal}
        />
    )
}

export default ExportConnectedAccountModal
